module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "title": "Modification du jalon"
    },
    on: {
      "close": function($event) {
        _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "jalon-details"
  }, [(_vm.mode === 'delete') ? _c('div', {
    staticClass: "delete"
  }, [_c('strong', [_vm._v("Êtes-vous sûr de bien vouloir supprimer " + _vm._s(_vm.returnJalonMessage()))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.toggleDelete()
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.doDelete()
      }
    }
  }, [_vm._v("Supprimer")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a303e70!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/rondes/RondeDebutFinJalonDeleteModal.vue
// module id = 1861
// module chunks = 2